module Client.Admin.EnableUser.Grid

open Shared
open Client
open Client.Admin
open Elmish
open Illy.SafeStack.Client 
open Illy.SafeStack.Client.jQueryUI
open Fable.React
open Shared.Admin
open SafeStack.Client

type Model =
    {
        Grid: UserGrid.Model
        Enable: Enable.Model option
    }

type Msg =
    | UserGridMsg of UserGrid.Msg
    | EnableMsg of Enable.Msg
    | EnableUser of UserId
    | NotificationWasHidden

type Event =
    | ApiError of ApiError
    | CloseOverlay

let init () =
    let m, c = UserGrid.init {UserGrid.IncludeUsersFilter.all with Enabled = false}
    {
        Grid = m
        Enable = None
    }, Cmd.map UserGridMsg c

let dispatchEnableMsg model msg =
    match model.Enable with 
    | None -> model, SideEffect.none
    | Some enable ->
        let m, eff = Enable.update msg enable
        match eff with
        | SideEffect.Cmd c -> {model with Enable = Some m}, Cmd.map EnableMsg c |> SideEffect.Cmd
        | SideEffect.Event ev ->
            match ev with
            | Enable.Event.ApiError err ->
                {model with Enable = Some m}, err |> ApiError |> SideEffect.Event
            | Enable.Event.CloseOverlay ->
                {model with Enable = None}, SideEffect.none
            | Enable.Event.SaveSuccessful notification ->
                {model with Enable = None},
                Cmd.batch [
                    Notification.success notification NotificationWasHidden
                    Cmd.ofMsg (UserGrid.Msg.RefreshGrid |> UserGridMsg)
                ] |> SideEffect.Cmd

let update msg (model: Model) =
    match msg with
    | UserGridMsg uMsg ->
        let m, eff = UserGrid.update uMsg model.Grid
        {model with Grid = m},
        match eff with 
        | SideEffect.Cmd c -> Cmd.map UserGridMsg c |> SideEffect.Cmd
        | SideEffect.Event ev ->
            match ev with
            | UserGrid.Event.ApiError err -> err |> ApiError |> SideEffect.Event
            | UserGrid.Event.CloseOverlay -> CloseOverlay |> SideEffect.Event
    | EnableUser uId ->
        let m, c = Enable.init uId
        {model with Enable = Some m}, Cmd.map EnableMsg c |> SideEffect.Cmd
    | EnableMsg eMsg -> dispatchEnableMsg model eMsg
    | NotificationWasHidden -> model, SideEffect.none

let view (model: Model) dispatch =
    [
        if model.Enable.IsNone then 
            yield! UserGrid.viewModal "Re-enable user accounts" model.Grid (UserGridMsg >> dispatch) [
                UserGrid.GridColumn.nameWithTooltip
                    (UserGrid.isLoadingMoreResults model.Grid)
                    model.Grid.SortInfo
                    (UserGridMsg >> dispatch)
                    (fun x -> x.DisabledReason)
                UserGrid.GridColumn.username (UserGrid.isLoadingMoreResults model.Grid) model.Grid.SortInfo (UserGridMsg >> dispatch)
                Some [ str "Actions" ] ===> fun u -> [ UI.button "Enable" (EnableUser (UserId u.Id)) dispatch ]
            ]
        yield! jQueryUI.conditionallyRenderView model.Enable Enable.view EnableMsg dispatch
    ]
    
    
    
